import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import familyImage from '@/assets/images/subscription/1.webp';
import { Button } from '@/components/Button';
import { CheckCircleGreen } from '@/components/Icons/CheckCircleGreen';
import { useStatusCard } from '@/pages/Subscription/hooks/useStatusCard';
import { ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS } from '@/router/routes';
import { BorderRadius, ButtonVariant, Size } from '@/types/components';

export const Checklist: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { canPurchase } = useStatusCard();

  const benefits = t('subscription.intro.checklist.benefits', {
    returnObjects: true,
  }) as string[];

  return (
    <div className="px-4 py-6 md:p-8">
      <h2 className="hidden pb-6 text-title-24 text-foreground md:block md:pb-8">
        {t('subscription.intro.checklist.heading')}
      </h2>
      <div className="flex items-end gap-6 overflow-hidden rounded-2xl bg-card">
        <div className="flex min-w-0 flex-1 flex-col gap-4 p-6 md:p-8">
          <p className="text-[22px]/[28px] font-semibold text-foreground md:text-[20px]/[28px] md:font-medium">
            {t('subscription.intro.checklist.subheading')}
          </p>
          <ul className="flex flex-col gap-4">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-start gap-2">
                <CheckCircleGreen className="size-6 shrink-0" />
                <p className="text-body-16 text-subtle-foreground">{benefit}</p>
              </li>
            ))}
          </ul>
          <Button
            variant={ButtonVariant.Primary}
            size={Size.Medium}
            radius={BorderRadius.Pill}
            disabled={!canPurchase}
            className="mt-2 w-fit mx-auto md:mx-0"
            onClick={() => navigate(ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS)}
          >
            {t('subscription.intro.activeButton')}
          </Button>
        </div>
        <img
          src={familyImage}
          alt=""
          className="hidden w-[280px] shrink-0 self-end pt-6 pr-6 md:pt-8 md:pr-8 lg:block xl:w-[360px]"
        />
      </div>
    </div>
  );
};
